export default __webpack_public_path__ + "static/media/AcceleronsGallery_40.42c2ce47.webp";